import type { CSSObject } from 'styled-components';

/*
 * https://hugogiraudel.com/2016/10/13/css-hide-and-seek/
 * https://gist.github.com/ffoodd/000b59f431e3e64e4ce1a24d5bb36034
 *
 * 1.
 * @note `clip` is deprecated but works everywhere
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/clip
 *
 * 2.
 * @note `clip-path` is the future-proof version, but not very well supported yet
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/clip-path
 * @see http://caniuse.com/#search=clip-path
 *
 * 3.
 * @note preventing text to be condensed
 * @see https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
 */

export const visuallyHiddenStyle: CSSObject = {
  border: '0',
  clip: 'rect(1px, 1px, 1px, 1px)' /* 1 */,
  clipPath: 'inset(50%)' /* 2 */,
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: '0',
  position: 'absolute',
  whiteSpace: 'nowrap' /* 3 */,
  width: '1px',
};
